<template>
	<div>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'ContentWatcher',

	data() {
		return {
			elements: [],
		};
	},

	mounted() {
		this.elements = [
			...this.$el.getElementsByTagName('body'),
			...this.$el.getElementsByTagName('embed'),
			...this.$el.getElementsByTagName('frame'),
			...this.$el.getElementsByTagName('iframe'),
			...this.$el.getElementsByTagName('img'),
			...this.$el.getElementsByTagName('link'),
			...this.$el.getElementsByTagName('picture'),
			...this.$el.getElementsByTagName('script'),
			...this.$el.getElementsByTagName('style'),
			...this.$el.getElementsByClassName('helio-table'),
		];

		this.elements.forEach((elem) => {
			elem.addEventListener('load', this.emitLoaded);
		});
	},

	beforeDestroy() {
		this.elements.forEach((elem) => {
			elem.removeEventListener('load', this.emitLoaded);
		});
	},

	methods: {
		emitLoaded() {
			this.$emit('loaded');
		},
	},
};
</script>
